var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownloadSimple = function SvgIconDownloadSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.75a1 1 0 0 1 1 1v8.086l2.23-2.23a1 1 0 1 1 1.415 1.414l-3.938 3.937a1 1 0 0 1-1.414 0L7.355 11.02A1 1 0 0 1 8.77 9.605l2.23 2.23V3.75a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.25a1 1 0 0 1 1 1v5h14.5v-5a1 1 0 1 1 2 0v5.25a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75v-5.25a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconDownloadSimple;